import React from 'react';

const CURRENT_YEAR = new Date().getFullYear();

const Footer = () => {
  // Force a full browser navigation so Django serves the page,
  // bypassing React's internal link interception.
  const hardNav = (e) => {
    e.preventDefault();
    window.location.href = e.currentTarget.href;
  };

  return (
    <footer style={s.footer}>
      <div style={s.inner}>

        {/* Brand + tagline */}
        <div style={s.brand}>
          <span style={s.brandName}>WeeklyDefense.com</span>
          <span style={s.tagline}>Independent defense & military news analysis</span>
        </div>

        {/* Nav links */}
        <nav style={s.nav} aria-label="Footer navigation">
          <a href="/about/" style={s.link} onClick={hardNav}>About Us</a>
          <span style={s.sep}>·</span>
          <a href="/contact/" style={s.link} onClick={hardNav}>Contact</a>
          <span style={s.sep}>·</span>
          <a href="/advertise/" style={s.link} onClick={hardNav}>Advertise</a>
          <span style={s.sep}>·</span>
          <a href="/privacy/" style={s.link} onClick={hardNav}>Privacy Policy</a>
          <span style={s.sep}>·</span>
          <a href="/terms/" style={s.link} onClick={hardNav}>Terms of Use</a>
        </nav>

        {/* Copyright */}
        <p style={s.copy}>
          &copy; {CURRENT_YEAR} WeeklyDefense.com — All rights reserved.
          Content aggregated from publicly available sources.
        </p>

      </div>
    </footer>
  );
};

const s = {
  footer: {
    background: '#0f172a',
    borderTop: '1px solid #1e293b',
    padding: '2rem 2rem 1.5rem',
    marginTop: 'auto',
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    textAlign: 'center',
  },
  brand: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.25rem',
  },
  brandName: {
    color: '#f1f5f9',
    fontWeight: 800,
    fontSize: '1.1rem',
    fontFamily: "'Georgia', 'Times New Roman', serif",
    letterSpacing: '-0.01em',
  },
  tagline: {
    color: '#475569',
    fontSize: '0.78rem',
    letterSpacing: '0.03em',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '0.25rem',
  },
  link: {
    color: '#64748b',
    textDecoration: 'none',
    fontSize: '0.82rem',
    fontWeight: 500,
    padding: '0.2rem 0.4rem',
    borderRadius: 4,
    transition: 'color 0.2s',
  },
  sep: {
    color: '#1e293b',
    fontSize: '0.75rem',
    userSelect: 'none',
  },
  copy: {
    color: '#334155',
    fontSize: '0.75rem',
    margin: 0,
    lineHeight: 1.6,
  },
};

export default Footer;